import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "@/firebaseConfig.js";
import Button from "./Button";

import { FirebaseError } from "firebase/app";
import { errorMessages } from "@/assets/data/firebaseErrorMessage";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email.toLowerCase());
      setSuccessMessage(
        "Password reset link has been sent. If this email is registered, you will receive an email. Please check your inbox and don’t forget to check your SPAM (Unwanted) folder."
      );
      setErrorMessage("");
    } catch (error) {
      if (error instanceof FirebaseError) {
        setErrorMessage(errorMessages[error.message] || errorMessages.default);
      } else {
        setErrorMessage(errorMessages.default);
      }
      setSuccessMessage("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className="authentication-box__title">Reset password</h2>
      {errorMessage && (
        <p className="authentication-box__error"> {errorMessage} </p>
      )}
      {successMessage && (
        <p className="authentication-box__success"> {successMessage} </p>
      )}
      <label htmlFor="email">Email</label>
      <input
        className={`input`}
        required
        value={email}
        id="email"
        name="email"
        type="email"
        placeholder="you@example.com"
        onChange={(event) => setEmail(event.target.value)}
      />

      <Button
        title={loading ? "Sending" : "Send"}
        onClick={handlePasswordReset}
      />
    </>
  );
};

export default ResetPassword;
